module.exports = __webpack_public_path__ + "img/INTERIOR-BALENO-1.15340a26.jpg";